import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'vb-lxp-header',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './vb-lxp-header.component.html',
  styleUrl: './vb-lxp-header.component.css',
})
export class VbLxpHeaderComponent {
  // Center header
  centerImageSrc = input<string>('');
  centerImageAlt = input<string>('Logo');
  logoLink = input<string>('');
  logoLinkTarget = input<string>('_self');

  // Left side header (optional)
  eventTitle = input<string>('');
  eventSubtitle = input<string>('');
  elapsedTime = input<string>('');
  remainingTime = input<string>('');
  showLiveIndicator = input<boolean>(false);
}
